import React from "react";
import PropTypes from "prop-types";
import PageTitle from "../common/PageTitle";
import RecipeTable from "../recipes/RecipeTable";

function ProfilePage({ viewingUser, selectUserRecipe }) {
  return (
    <div className="page">
      <PageTitle title={viewingUser.username || ""} />
      <div className="profile">
        <h3>Recipes:</h3>
        <RecipeTable
          recipes={viewingUser.recipes || []}
          select={selectUserRecipe}
        />
      </div>
    </div>
  );
}

ProfilePage.propTypes = {
  viewingUser: PropTypes.object,
  selectUserRecipe: PropTypes.func,
};

export default ProfilePage;
